import { Column } from '@repo/ui/data-table'

import OlNameNavigatorLink from '../common/ol-name-navigator-link'

export const olNameColumn = <
  T extends { ol: { id: number; mainContactFirstName?: string; mainContactLastName: string } }
>(): Column<T> => ({
  accessorKey: 'ol',
  header: "Nom de l'OL",
  cell: ({ row }) => <OlNameNavigatorLink ol={row.original.ol} />
})
